window.onload = () => {
  const scroller = document.getElementById('logoScroller');
  let scrollWidth = scroller.scrollWidth;
  let containerWidth = scroller.parentElement.offsetWidth;

  const scrollSpeed = 2;  // adjust for scrolling speed

  function startScrolling() {
    scroller.style.transform = `translateX(-${scrollSpeed}px)`;
    scrollWidth -= scrollSpeed;
    
    if (scrollWidth <= 0) {
      // Reset scroll when it reaches the end
      scroller.style.transform = 'translateX(0)';
      scrollWidth = scroller.scrollWidth;
    }

    requestAnimationFrame(startScrolling);
  }

  startScrolling();
}
